import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerKeyValuePairService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/customerkeyvaluepairs`;

  constructor(private http: HttpClient) { }

  save(keyvaluepair: Boo.Objects.CustomerKeyValuePair): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/Save`, keyvaluepair);
  }

  get(customerId: number): Observable<Boo.Objects.CustomerKeyValuePair[]> {
    return this.http.get<Boo.Objects.CustomerKeyValuePair[]>(`${this.baseUrl}/customer/${customerId}`, {
    });
  }
}
